module.exports = __webpack_public_path__ + "templates.destination-section-cd379eb0.html";